/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonSharedAcademicEducationDropdown200,
  GetApiV1PersonSharedAcademicEducationDropdown401,
  GetApiV1PersonSharedAcademicEducationDropdown500,
  GetApiV1PersonSharedAcademicEducationDropdownQueryResponse,
} from "../../types/personSharedController/GetApiV1PersonSharedAcademicEducationDropdown.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonSharedAcademicEducationDropdown200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1PersonSharedAcademicEducationDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonSharedAcademicEducationDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedAcademicEducationDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonSharedAcademicEducationDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedAcademicEducationDropdown500>;

export const getApiV1PersonSharedAcademicEducationDropdownQueryResponseSchema =
  z.lazy(
    () => getApiV1PersonSharedAcademicEducationDropdown200Schema,
  ) as unknown as ToZod<GetApiV1PersonSharedAcademicEducationDropdownQueryResponse>;
